


















































import { Component, Vue } from "vue-property-decorator";
import { User } from "@/components/User";

@Component
export default class Login extends Vue {
  protected username: string = '';
  protected password: string = '';
  protected errorMessage: string = null;

  get User() : User {
    return this.$store.getters.User;
  }

  set User(user:User) {
    this.$store.commit('notifyChange', {
      User: user
    });
  };

  async login() {
    try {
      let user = new User();
      let ok = await user.login(this.username, this.password);
      this.User = user;
      this.$emit('changeMe',{
        menu: {
          name: 'after_login',
          title: user.FullName
        },
        data: user
      });
    } catch (error) {
      this.errorMessage = 'loginWasNotSuccessful';
    }
  };

  forgotPassword() {
    this.$emit('changeMe',{
      menu: {
        name: 'user_forgotpassword'
      }
    });
  }

  register() {
    this.$emit('changeMe',{
      menu: {
        name: 'user_register'
      }
    });
  }

  closeMe() {
    this.$emit('closeRightToc');
  }
}
